import * as React from 'react'
import { Route, SprocketAsset } from '../../../types/types'

type MobileProps = {
  kind: 'mobile'
} & { route: Route }

type DesktopProps = {
  kind: 'desktop'
  asset: SprocketAsset
} & { route: Route }

type Props = MobileProps | DesktopProps

export const ArrowIcon = (
  <svg
    className="lastminute__arrow"
    height="16"
    viewBox="0 0 24 16"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g
      fill="none"
      stroke="#2a0f4a"
      stroke-linecap="round"
      stroke-width="3"
      transform="translate(2 2)"
    >
      <path d="m.29032258 6.5h17.41935482" />
      <path
        d="m14 0 6 6.06822494-5.6182891 5.93177506"
        stroke-linejoin="round"
      />
    </g>
  </svg>
)

const ClockIcon = (
  <svg
    className="lastminute__clock"
    height="33"
    viewBox="0 0 33 33"
    width="33"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="#2a0f4a"
      stroke-width="3"
      transform="translate(2 2)"
    >
      <circle cx="14.5" cy="14.5" r="14.5" />
      <path d="m14.5 5.89745954v8.60254046l6.0827252 5.1413901" />
    </g>
  </svg>
)

export default (props: Props): JSX.Element =>
  props.kind === 'mobile' ? (
    <a className="lastminute__wrap" href={props.route.url}>
      <div className="lastminute">
        {ClockIcon}
        <div>
          <p className="lastminute__text">
            {I18n.t('last_minutes.sticker_text')}
          </p>
          <p className="lastminute__text lastminute__text--xl">
            {I18n.t('last_minutes.label')}
          </p>
        </div>

        {ArrowIcon}
      </div>
    </a>
  ) : (
    <a className="sticker sticker--home-desktop" href={props.route.url}>
      <div className="sticker__inner">
        <img
          className="sticker__image"
          alt={I18n.t('last_minutes.title')}
          src={props.asset.url}
        />
        <span className="sticker__label">
          {I18n.t('last_minutes.view_offers')}
        </span>
        <span className="sticker__arrow icon-arrow-right" />
      </div>
    </a>
  )

